export const Logo = ({ className = "h-8 w-auto", showText = true }) => (
  <div className="flex items-center gap-2" data-testid="brand-logo">
    <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="20" cy="20" r="17" stroke="#FF4500" strokeWidth="2.5" />
      <circle cx="20" cy="6.5" r="2.2" fill="#FF4500" />
      <rect x="18.7" y="9.5" width="2.6" height="12" rx="1.3" fill="#FF4500" />
      <circle cx="20" cy="20" r="2.4" fill="#FF4500" />
    </svg>
    {showText && (
      <span className="font-display font-black text-lg tracking-tighter leading-none">
        12<span className="text-[#FF4500]">O'CLOCK</span>
      </span>
    )}
  </div>
);

export default Logo;
